<template>
  <div class="podcast-trailer">
    <div class="trailer-play">
      <picture-component
        v-if="trailerData.uuid"
        :src="trailer.display_image_url"/>
      <div
        class="play-icon"
        @click="playTrailer" >
        <i
          v-if="!isLoading"
          :class="'fas ' + (isPlaying ? 'fa-pause' : 'fa-play')" />
        <div v-if="isLoading">
          <i
            class="el-icon-loading"/>
        </div>
      </div>
    </div>
    <div class="trailer-header">
      {{ trailer.title | truncate(text_limit) }}
    </div>
    <!-- <premium-modal
      v-if="show_premium_modal"
      :show_modal="show_premium_modal"
      @modalClosed="show_premium_modal = false"/> -->
  </div>
</template>
<script>
// import * as log from 'loglevel';
import imgPlaceholder from '../assets/images/placeholder.png';
import Event from '../services/PlayerEvent';
import PremiumContentModal from './PremiumContentModal';

export default {
  name: 'PodcastTrailer',
  components: {
    'premium-modal': PremiumContentModal,
  },
  props: {
    trailer: {
      type: Object,
      default: () => {},
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgPlaceholder,
      text_limit: 30,
      is_loading: false,
      trailerData: {},
      eventProvider: new Event(),
      show_premium_modal: false,
    };
  },
  computed: {
    // image_url() {
    //   return this.trailerData.season
    //     && this.trailerData.season.podcast
    //     && this.trailerData.season.podcast.image_url ? this.trailerData.season.podcast.display_image_url
    //     : this.trailerData.default_image_url;
    // },
    isPlaying() {
      const { play } = this.$store.getters;

      return play && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.trailerData.uuid);
    },
    isLoading() {
      const { status } = this.$store.getters;

      return (status === 'loading') && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.trailerData.uuid);
    },
    currentlyPlaying() {
      return this.$store.getters.episode;
    },
  },
  watch: {
    trailer(newVal) {
      if (newVal) {
        this.trailerData = newVal;
        this.trailerData.episode_type = 'trailer';
      }
    },
  },
  mounted() {
    this.trailerData = { ...this.trailer };
    this.trailerData.episode_type = 'trailer';
    if (window.innerWidth <= 567) {
      this.text_limit = 20;
    } else if (window.innerWidth <= 768) {
      this.text_limit = 30;
    }
  },
  methods: {
    playTrailer() {
      if (!this.isLoading) {
        this.$store.dispatch('setPlaylistType', 'trailers');
        const currentEpisode = this.$store.getters.episode;

        if (currentEpisode && currentEpisode.uuid === this.trailerData.uuid) {
          const { play } = this.$store.getters;
          if (play) {
            this.$store.dispatch('pause');
            this.eventProvider.triggerTrailerPauseEvent(this.trailerData, 'homescreen_pause');
          } else {
            this.$store.dispatch('play');
          }
        } else {
          if (currentEpisode.episode_type !== 'trailer') { // for now we are receiving item_type
            this.eventProvider.triggerEpisodePauseEvent(currentEpisode, 'trailer_select');
          }
          this.loadMediaInPlayer(this.trailerData.media_url, this.trailerData.is_exclusive);
          this.$store.dispatch('setAndPlayEpisode', this.trailerData);
          this.eventProvider.triggerTrailerPlayEvent(this.trailerData, 'homescreen_select');
        }

        this.$emit('play', this.trailerData.uuid);
      }
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
@import "../assets/scss/mixins.scss";

$font-size: 16;
$line-height: 20;
$lines-to-show: 2;

.podcast-trailer {
  margin-right: 16px;
  text-align: center;
  width: 166px;
  height: 219px;
  .trailer-play {
    width: 100%;
    height: 166px;
    border-radius: 50%;
    margin-bottom: 11px;
    box-shadow: 2px 2px 6px 1px #ccc;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.25rem;
      height: 3rem;
      width: 3rem;
      border-radius: 50%;
      color: $white;
      background: rgba($black, 0.8);
      z-index: 1;

      > i, div {
        position: absolute;
        top: 51.5%;
        left: 51.5%;
        transform: translateX(-50%) translateY(-50%);

        &.fa-play {
          left: 52.5%;
        }
      }

      transition: 150ms ease;
    }
    picture {
      img {
      }
      source {
      }
    }

    &:hover {
      .play-icon {
        background-color: $blue;
      }
    }
  }
  .trailer-header {
    text-transform: capitalize;
    text-align: center;
    font-size: 14px;
    height: 42px;
    line-height: 18px;
  }
}

@media (max-width : 1024px) {
  .podcast-trailer {
    width: 157px;
    height: 210px;
    .trailer-play {
      height: 157px;
    }
  }
}

@media (max-width : 768px) {
  .podcast-trailer {
    width: 147px;
    height: 200px;
    .trailer-play {
      height: 147px;
    }
  }
}

@media (max-width : 375px) {
  .podcast-trailer {
    width: 114px;
    height: 197px;
    .trailer-play {
      height: 114px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PodcastTrailer.vue